























import { compile } from 'path-to-regexp'
import { Component, Vue, Watch } from 'vue-property-decorator'
import { RouteRecord, Route } from 'vue-router'
import { isObserverAgent } from '@/utils/permission'

@Component({
  name: 'Breadcrumb'
})
export default class extends Vue {
  private breadcrumbs: RouteRecord[] = []

  @Watch('$route')
  private onRouteChange (route: Route) {
    if (route.path.startsWith('/redirect/')) {
      return
    }
    this.getBreadcrumb()
  }

  created () {
    this.getBreadcrumb()
  }

  private getBreadcrumb () {
    let matched:any = this.$route.matched.filter((item) => item.meta && item.meta.title)
    const first = matched[0]
    // observer / pingwei 不展示首页 dashboard 面包屑
    if (!isObserverAgent() && !this.isDashboard(first)) {
      const dashborardPath = [{ path: '/dashboard', meta: { title: '首页' } }]
      matched = [...dashborardPath, ...matched]
    }
    this.breadcrumbs = matched.filter((item:RouteRecord) => {
      return item.meta && item.meta.title && item.meta.breadcrumb !== false
    })
  }

  private isDashboard (route: RouteRecord) {
    const name = route && route.name
    if (!name) {
      return false
    }
    return name.trim().toLocaleLowerCase() === 'Dashboard'.toLocaleLowerCase()
  }

  private pathCompile (path: string) {
    const { params } = this.$route
    const toPath = compile(path)
    return toPath(params)
  }

  private handleLink (item: any) {
    const { redirect, path } = item
    if (redirect) {
      this.$router.push(redirect).catch(err => {
        console.warn(err)
      })
      return
    }
    this.$router.push(this.pathCompile(path)).catch(err => {
      console.warn(err)
    })
  }
}
